import { getAbsoluteUrl, getEnv, getEnvStringValue } from './env.helpers';

export const environment = {
    get REDUX_DEV_TOOLS() {
        return getEnv<boolean | undefined>('NEXT_PUBLIC_REDUX_DEV_TOOLS');
    },
    get CHECKOUT_API_END_POINT() {
        return getAbsoluteUrl(
            getEnvStringValue('NEXT_PUBLIC_CHECKOUT_API_ENDPOINT', 'CHECKOUT_API_ENDPOINT') ?? '',
        );
    },
    get ACCOMMODATION_API_ENDPOINT() {
        return getAbsoluteUrl(
            getEnvStringValue(
                'NEXT_PUBLIC_ACCOMMODATION_API_ENDPOINT',
                'ACCOMMODATION_API_ENDPOINT',
            ) ?? '',
        );
    },
    get NOC_API_END_POINT() {
        return getAbsoluteUrl(
            getEnvStringValue('NEXT_PUBLIC_NOC_API_ENDPOINT', 'NOC_API_ENDPOINT') ?? '',
        );
    },
    get CROSSSTORAGE_ENDPOINT() {
        return getEnvStringValue('NEXT_PUBLIC_CROSSSTORAGE_ENDPOINT');
    },
    get API_DATE_FORMAT() {
        return getEnvStringValue('NEXT_PUBLIC_API_DATE_FORMAT');
    },
    get GFX_SERVER() {
        return getEnvStringValue('NEXT_PUBLIC_GFX_SERVER');
    },
    get CONSENTS_URLS() {
        return {
            privacyPolicy: getEnvStringValue('NEXT_PUBLIC_CONSENTS_URLS_PRIVACY_POLICY'),
            reservationTermsSzallas: getEnvStringValue(
                'NEXT_PUBLIC_CONSENTS_URLS_RESERVATION_TERMS_SZALLAS',
            ),
            privacyPolicySzallas: getEnvStringValue(
                'NEXT_PUBLIC_CONSENTS_URLS_PRIVACY_POLICY_SZALLAS',
            ),
        };
    },
    get NOCOWANIE_URL() {
        return getEnvStringValue('NEXT_PUBLIC_NOCOWANIE_URL');
    },
    get NOCIMG_URL() {
        return getEnvStringValue('NEXT_PUBLIC_NOCIMG_URL');
    },
    get FACEBOOK_APP_ID() {
        return getEnvStringValue('NEXT_PUBLIC_FACEBOOK_APP_ID');
    },
    get GTM() {
        return {
            GTM_TAG_ID: getEnvStringValue('NEXT_PUBLIC_GTM_TAG_ID'),
            GTM_AUTH: getEnvStringValue('NEXT_PUBLIC_GTM_AUTH'),
            GTM_PREVIEW: getEnvStringValue('NEXT_PUBLIC_GTM_PREVIEW'),
        };
    },
    get SALESMANAGO_SMID() {
        return getEnvStringValue('NEXT_PUBLIC_SALESMANAGO_SMID');
    },
    get WPH_PIXEL_ID() {
        return getEnvStringValue('NEXT_PUBLIC_WPH_PIXEL_ID');
    },
    get SENTRY() {
        return {
            SENTRY_DSN: getEnvStringValue('NEXT_PUBLIC_SENTRY_DSN'),
            SENTRY_ENABLED: getEnv<boolean>('NEXT_PUBLIC_SENTRY_ENABLED'),
            SENTRY_ENVIRONMENT: getEnvStringValue(
                'NEXT_PUBLIC_SENTRY_ENVIRONMENT',
                'SENTRY_ENVIRONMENT',
            ),
            SENTRY_PROJECT_NAME: getEnvStringValue('NEXT_PUBLIC_SENTRY_PROJECT_NAME'),
            TUNNEL_URL: getEnvStringValue('NEXT_PUBLIC_SENTRY_TUNNEL_URL'),
        };
    },
    get SSR_API_HOST() {
        return getAbsoluteUrl(getEnvStringValue('NEXT_PUBLIC_SSR_API_HOST', 'SSR_API_HOST') ?? '');
    },
    get ASSETS_PATH() {
        return getEnvStringValue('NEXT_PUBLIC_ASSETS_PATH') ?? '';
    },
    get ASSETS_PREFIX() {
        return getEnvStringValue('NEXT_PUBLIC_ASSETS_PREFIX') ?? '';
    },
    get CEPH_URL() {
        return getEnvStringValue('NEXT_PUBLIC_CEPH_URL') ?? '';
    },
    get SESSION_ID_COOKIE() {
        return getEnvStringValue('NEXT_PUBLIC_SESSION_ID_COOKIE');
    },
    get SM_ENDPOINT() {
        return getEnvStringValue('SM_ENDPOINT') ?? '';
    },
    get SM_CLIENT_ID() {
        return getEnvStringValue('SM_CLIENT_ID') ?? '';
    },
    get SM_API_KEY() {
        return getEnvStringValue('SM_API_KEY') ?? '';
    },
    get SM_SHA() {
        return getEnvStringValue('SM_SHA') ?? '';
    },
    get SM_OWNER_EMAIL() {
        return getEnvStringValue('SM_OWNER_EMAIL') ?? '';
    },
    get AUTOCOMPLETE_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_AUTOCOMPLETE_ES_VERSION') ?? 2;
    },
    get GEO_TILES_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_GEO_TILES_ES_VERSION') ?? 1;
    },
    get HOME_PAGE_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_HOME_PAGE_ES_VERSION') ?? 1;
    },
    get ACCOMMODATION_PAGE_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_ACCOMMODATION_PAGE_ES_VERSION') ?? 1;
    },
    get IMAGE_MULTIPLIER() {
        return getEnv<number>('NEXT_PUBLIC_IMAGE_MULTIPLIER') ?? 1;
    },
    get REVIEWS_PAGINATION_LIMIT() {
        return getEnv<number>('NEXT_PUBLIC_REVIEWS_PAGINATION_LIMIT') ?? 10;
    },
    get ACCOMMODATION_WC_APP() {
        return getEnvStringValue('ACCOMMODATION_WC_APP');
    },
    get REGISTRATION_WC_APP() {
        return getEnvStringValue('ACCOMMODATION_WC_APP');
    },
    get GOOGLE_MAPS_API_KEY() {
        return getEnvStringValue('NEXT_PUBLIC_GOOGLE_MAPS_API_KEY');
    },
    get GOOGLE_MAPS_MAP_ID() {
        return getEnvStringValue('NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID');
    },
    get COOKIE_DOMAIN() {
        return getEnvStringValue('NEXT_PUBLIC_COOKIE_DOMAIN');
    },
    get DEFAULT_FLEX_DATES() {
        return getEnv<number>('NEXT_PUBLIC_DEFAULT_FLEX_DATES') ?? 0;
    },
    get OTA_RATING_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_OTA_RATING_ES_VERSION');
    },
    get LINKSPACES_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_LINKSPACES_ES_VERSION');
    },
    get LISTING_BREADCRUMBS_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_LISTING_BREADCRUMBS_ES_VERSION') ?? 1;
    },
    get POI_ES_VERSION() {
        return getEnv<number | undefined>('NEXT_PUBLIC_POI_ES_VERSION') ?? 1;
    },
    get CMS_API_ENDPOINT() {
        return getEnvStringValue('CMS_API_ENDPOINT') ?? '';
    },
    get CMS_API_TOKEN() {
        return getEnvStringValue('CMS_API_TOKEN');
    },
    get CMS_PREVIEW_SECRET() {
        return getEnvStringValue('CMS_PREVIEW_SECRET');
    },
    get API_TIMEOUT() {
        return getEnv<number>('NEXT_PUBLIC_API_TIMEOUT', 'API_TIMEOUT') ?? 3000;
    },
    get SMART_BANNER_URL() {
        return (
            getEnvStringValue('NEXT_PUBLIC_SMART_BANNER_URL') || 'https://smart.link/ggru4xy9zq545'
        );
    },
    get GROWTHBOOK() {
        return {
            API_HOST: getEnvStringValue('GROWTHBOOK_API_HOST') ?? '',
            CLIENT_KEY: getEnvStringValue('GROWTHBOOK_CLIENT_KEY') ?? '',
            WEBHOOK_TOKEN: getEnvStringValue('GROWTHBOOK_WEBHOOK_TOKEN') ?? '',
            DEFAULT_TIMEOUT: getEnv<number>('GROWTHBOOK_DEFAULT_TIMEOUT') ?? 2000,
            REVALIDATE_TIME: getEnv<number>('GROWTHBOOK_REVALIDATE_TIME') ?? 10000,
            REVALIDATE_TAG: getEnvStringValue('GROWTHBOOK_REVALIDATE_TAG') ?? 'growthbook',
        };
    },
    get METADATA_TITLE_PRICE_DEFAULT() {
        return getEnv<number>('METADATA_TITLE_PRICE_DEFAULT') ?? 65;
    },
    get HIGH_PRIORITY_IMAGE_COUNT_DESKTOP() {
        return (
            getEnv<number>(
                'NEXT_PUBLIC_HIGH_PRIORITY_IMAGE_COUNT_DESKTOP',
                'HIGH_PRIORITY_IMAGE_COUNT_DESKTOP',
            ) ?? 3
        );
    },
    get HIGH_PRIORITY_IMAGE_COUNT_MOBILE() {
        return (
            getEnv<number>(
                'NEXT_PUBLIC_HIGH_PRIORITY_IMAGE_COUNT_MOBILE',
                'HIGH_PRIORITY_IMAGE_COUNT_MOBILE',
            ) ?? 2
        );
    },
};
